"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCustomerResultWithAddressBookAllOfToJSON = exports.ChangeCustomerResultWithAddressBookAllOfFromJSONTyped = exports.ChangeCustomerResultWithAddressBookAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChangeCustomerResultWithAddressBookAllOfFromJSON(json) {
    return ChangeCustomerResultWithAddressBookAllOfFromJSONTyped(json, false);
}
exports.ChangeCustomerResultWithAddressBookAllOfFromJSON = ChangeCustomerResultWithAddressBookAllOfFromJSON;
function ChangeCustomerResultWithAddressBookAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'addressBook': !(0, runtime_1.exists)(json, 'addressBook') ? undefined : (json['addressBook'].map(_1.AddressWithIdFromJSON)),
        'inlineErrors': !(0, runtime_1.exists)(json, 'inlineErrors') ? undefined : (0, _1.AddressInlineErrorMessagesFromJSON)(json['inlineErrors']),
    };
}
exports.ChangeCustomerResultWithAddressBookAllOfFromJSONTyped = ChangeCustomerResultWithAddressBookAllOfFromJSONTyped;
function ChangeCustomerResultWithAddressBookAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'addressBook': value.addressBook === undefined ? undefined : (value.addressBook.map(_1.AddressWithIdToJSON)),
        'inlineErrors': (0, _1.AddressInlineErrorMessagesToJSON)(value.inlineErrors),
    };
}
exports.ChangeCustomerResultWithAddressBookAllOfToJSON = ChangeCustomerResultWithAddressBookAllOfToJSON;
//# sourceMappingURL=ChangeCustomerResultWithAddressBookAllOf.js.map